import { api } from '../serverClient';

// The Battlemage at runtime, display side. Rules and every number live on
// the server in valkenhall-server/src/utils/battlemage.js; this file mirrors
// the caps the surfaces draw and names the server calls. Keep the
// arithmetic in lockstep.

export const BASE_MAX_RUSH = 3;
export const BASE_MAX_FEROCITY = 100;
export const GUARD_COST = 100;
export const QUEST_REROLL_COST = 25;
export const FOIL_REROLL_COST = 50;

const has = (state, key) => Boolean(state?.pointsSpent?.includes(key));
export const isBattlemage = (state) => state?.classKey === 'battlemage';
export const canRush = (state) => isBattlemage(state) && has(state, 'battlemage_rush');
export const hasFerocity = (state) => isBattlemage(state) && has(state, 'battlemage_bloodshed');
export const canGuard = (state) => hasFerocity(state) && !has(state, 'battlemage_all');
// The board asks for a standing once Ferocity is in play: the chip reads it.
export const hasStanding = hasFerocity;
// The Glory: the Arcane Trials screen offers its re-rolls.
export const canRerollTrials = (state) => hasFerocity(state) && has(state, 'battlemage_glory');

// The stack cap; null under The Conquest Continues (no cap).
export function maxRush(state) {
  if (!canRush(state)) return 0;
  if (has(state, 'battlemage_conquest')) return null;
  let max = BASE_MAX_RUSH;
  if (has(state, 'battlemage_march')) max += 1;
  if (has(state, 'battlemage_approach')) max += 1;
  return max;
}

// The cap the gauges draw: the base row of stacks before the foundation
// node is held, none at all without a cap.
export function displayRushMax(state) {
  const cap = maxRush(state);
  return cap == null ? null : Math.max(cap, BASE_MAX_RUSH);
}

export function maxFerocity(state) {
  if (!hasFerocity(state)) return 0;
  let max = BASE_MAX_FEROCITY;
  if (has(state, 'battlemage_uprise')) max += 30;
  if (has(state, 'battlemage_point')) max -= 50;
  return max;
}

const other = (seat) => (seat === 'p1' ? 'p2' : 'p1');

// This match's Ferocity so far, from the mirror's `stats`: the enemy
// Avatar's damage, doubled while Flawless Victory still holds.
export function ferocityProgress(stats, seat, state) {
  const dealt = stats?.[other(seat)]?.damageTaken || 0;
  const taken = stats?.[seat]?.damageTaken || 0;
  const flawless = has(state, 'battlemage_flawless') && taken === 0;
  return { dealt, taken, flawless, gained: flawless ? dealt * 2 : dealt };
}

// Server calls. Each answers { rush, ferocity, rushMax, ferocityMax, guardCost, canGuard, pending }.
export const fetchStanding = (roomCode) => api.post('/profile/me/battlemage/standing', { roomCode });
export const commitPledge = (roomCode, guard) => api.post('/profile/me/battlemage/commit', { roomCode, guard });
// Trial re-rolls answer the standing view plus `season` as the player now sees it.
export const rerollQuestSlot = (slot) => api.post('/profile/me/battlemage/quests/reroll', { slot });
export const rerollFoilTier = (level) => api.post('/profile/me/battlemage/foils/reroll', { level });
